var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 3.53134C5.81216 4.2109 5.54186 4.8625 5.06106 5.34278C4.58025 5.82306 3.92834 6.09269 3.24872 6.09235C2.5691 6.09201 1.91745 5.82173 1.43713 5.34097C0.956811 4.8602 0.687161 4.20834 0.6875 3.52878C0.68784 2.84922 0.958143 2.19763 1.43895 1.71734C1.91975 1.23706 2.57166 0.967434 3.25128 0.967774C3.9309 0.968114 4.58255 1.23839 5.06287 1.71916C5.54319 2.19992 5.81284 2.85178 5.8125 3.53134ZM5.88938 7.98972H0.764375V24.0296H5.88938V7.98972ZM13.9869 7.98972H8.8875V24.0296H13.9356V15.6125C13.9356 10.9235 20.0472 10.488 20.0472 15.6125V24.0296H25.1081V13.8702C25.1081 5.96552 16.0625 6.26018 13.9356 10.142L13.9869 7.98972Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInLogoBlack);
export default __webpack_public_path__ + "static/media/LinkedInLogoBlack.c1c287d2dc172091e8b549111d76fb59.svg";
export { ForwardRef as ReactComponent };